var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.064 39.435h-.623v-4.568a11.5 11.5 0 1 0-23 0v4.568h-.509a1.77 1.77 0 0 0-1.77 1.77V59.8a1.77 1.77 0 0 0 1.77 1.77h24.132a1.77 1.77 0 0 0 1.77-1.77V41.205a1.77 1.77 0 0 0-1.77-1.77ZM42.47 34.867a7.474 7.474 0 1 1 14.947 0v4.568H42.47Zm9.486 16.887v4.4a2.012 2.012 0 0 1-4.024 0v-4.399a3.953 3.953 0 1 1 4.024 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 91.213a1.51 1.51 0 0 1-.6-.126A62.886 62.886 0 0 1 11.77 33.5V21.745a1.5 1.5 0 0 1 1.053-1.432L49.554 8.854a1.507 1.507 0 0 1 .892 0l36.731 11.459a1.5 1.5 0 0 1 1.053 1.432V33.5A62.886 62.886 0 0 1 50.6 91.087a1.51 1.51 0 0 1-.6.126ZM14.77 22.849V33.5A59.89 59.89 0 0 0 50 88.072 59.89 59.89 0 0 0 85.23 33.5V22.849L50 11.858Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.fd3b29a7762a5295edcbfcf2b2e204a9.svg";
export { ForwardRef as ReactComponent };